import type { BackendModule, ReadCallback } from 'i18next'
import { DEFAULT_LANGUAGE, PSEUDO_LOCALE } from './languages'

/**
 * Loads `./locales/<lang>/<ns>.json` on demand. The template-literal import lets webpack split
 * every file into its own chunk, so a French reader page downloads French `common` and `reader`
 * and nothing else. A file that does not exist yet (a namespace not translated into that language)
 * loads as empty and i18next falls back to English for its keys.
 */
export const loadLocale = async (language: string, namespace: string): Promise<Record<string, unknown>> => {
  const folder = language === PSEUDO_LOCALE ? DEFAULT_LANGUAGE : language
  try {
    const module = await import(
      /* webpackChunkName: "locale-[request]" */
      `./locales/${folder}/${namespace}.json`
    )
    return (module.default || module) as Record<string, unknown>
  } catch {
    return {}
  }
}

export const localeBackend: BackendModule = {
  type: 'backend',
  init() {
    /* nothing to configure */
  },
  read(language: string, namespace: string, callback: ReadCallback) {
    loadLocale(language, namespace).then(
      (resources) => callback(null, resources as any),
      () => callback(null, {}),
    )
  },
}
